export const DATE_FORMAT = "YYYY-MM-DD";
export const DAYS_IN_WEEK = ["man", "tir", "ons", "tor", "fre", "lør", "søn"];
